import React from "react"
import { css } from "@emotion/react"
import ComingSoon from "../../../src/images/miscellaneous/parts/coming-soon.jpg"

type ImageSize = "big" | "medium" | "small"

export interface ImagePartPreviewProps extends React.ImgHTMLAttributes<HTMLImageElement> {
	src: string | undefined
	alt: string | undefined
	size: ImageSize
	withPadding?: boolean
}

export const ImagePartPreview = React.memo(
	({ src, alt, size = "small", loading = "lazy" }: ImagePartPreviewProps) => (
		<div css={imageContainer}>
			<img
				src={src?.trim() || ComingSoon}
				alt={alt ?? ""}
				loading={loading}
				css={imageStyles(size)}
			/>
		</div>
	)
)

const imageStyles = (size: ImageSize) => {
	const dimensions: Record<ImageSize, string> = {
		small: "3.125rem",
		medium: "5.6rem",
		big: "14rem",
	}

	return css`
		max-width: ${dimensions[size]};
		max-height: ${dimensions[size]};
		width: 100%;
		height: ${dimensions[size]};
		border-radius: 0.25rem;
		overflow: hidden;
		object-fit: cover;
		aspect-ratio: 1/1;
	`
}

const imageContainer = css`
	box-shadow: #d1d5db 0px 0px 0.375rem 0px;
	background-color: #ffffff;
	padding: 0.8rem;
	display: flex;
	justify-content: center;
	aspect-ratio: 1 / 1;
	align-items: center;
`
